
// © Microsoft Corporation. All rights reserved.

export enum OneTrustCookieCategory {
    /** Strictly Necessary Cookies */
    C0001 = "C0001",

    /** Advertising Cookies */
    C0002 = "C0002",

    /** Social Media Cookies */
    C0003 = "C0003",

    /** 3rd Party Analytics */
    C0004 = "C0004"
}